import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: '5941qkln',
  dataset: 'production',
  apiVersion: '2024-04-20',
  useCdn: true,
  withCredentials: false,
  ignoreBrowserTokenWarning: true
});

const builder = imageUrlBuilder(client);

export function urlFor(source: any) {
  return builder.image(source);
}

export async function fetchContent(type: string) {
  try {
    return await client.fetch(`*[_type == $type]`, { type });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error(`Error fetching ${type} content:`, error);
    }
    throw error;
  }
}

/** Live preview while editing in Studio — enable with VITE_SANITY_LIVE_MODE=true */
export const LIVE_MODE = import.meta.env.VITE_SANITY_LIVE_MODE === 'true';

export function subscribeToType(
  type: string,
  onUpdate: (docs: any[]) => void
): () => void {
  const query = '*[_type == $type]';
  const subscription = client
    .listen(query, { type })
    .subscribe({
      next: () => {
        client.fetch(query, { type }).then(onUpdate).catch((err) => {
          if (import.meta.env.DEV) {
            console.error(`Refetch failed for type ${type}:`, err);
          }
        });
      },
      error: (err) => {
        if (import.meta.env.DEV) {
          console.error(`Subscription error for type ${type}:`, err);
        }
      }
    });

  return () => subscription.unsubscribe();
}
